import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { REACTION_EMOJIS } from '@durakapp/shared';
import { emitReaction } from '../lib/gameSocket.js';
import { haptic } from '../lib/telegram.js';

export function ReactionPicker({ matchId }: { matchId: string }) {
  const [open, setOpen] = useState(false);
  const [cooldown, setCooldown] = useState(false);

  const send = (emoji: string): void => {
    if (cooldown) return;
    haptic('light');
    emitReaction(matchId, emoji);
    setCooldown(true);
    setOpen(false);
    setTimeout(() => setCooldown(false), 2500);
  };

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => {
          haptic('light');
          setOpen((v) => !v);
        }}
        aria-label="Эмоция"
        className="grid h-9 w-9 place-items-center rounded-full"
        style={{
          background: 'var(--color-glass)',
          border: '1px solid color-mix(in oklab, var(--color-gold) 35%, transparent)',
          color: 'var(--color-gold)',
        }}
      >
        <Smiley />
      </button>

      <AnimatePresence>
        {open && (
          <>
            <div className="fixed inset-0 z-30" onClick={() => setOpen(false)} />
            <motion.div
              initial={{ opacity: 0, y: 6, scale: 0.96 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 6, scale: 0.96 }}
              transition={{ duration: 0.16 }}
              className="absolute bottom-12 right-0 z-40 flex gap-1 rounded-full px-2 py-1.5"
              style={{
                background: 'color-mix(in oklab, var(--color-felt-deep) 95%, white 4%)',
                border: '1px solid color-mix(in oklab, var(--color-gold) 35%, transparent)',
                boxShadow: '0 14px 26px -14px rgba(0,0,0,0.6)',
              }}
            >
              {REACTION_EMOJIS.map((e) => (
                <button
                  key={e}
                  onClick={() => send(e)}
                  disabled={cooldown}
                  className="grid h-9 w-9 place-items-center rounded-full text-xl transition-transform hover:scale-110 disabled:opacity-40"
                >
                  {e}
                </button>
              ))}
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </div>
  );
}

function Smiley() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="9" />
      <line x1="9" y1="10" x2="9" y2="10.01" />
      <line x1="15" y1="10" x2="15" y2="10.01" />
      <path d="M8 14.5c1 1.4 2.4 2.2 4 2.2s3-.8 4-2.2" />
    </svg>
  );
}
